/**
 * Config class
 *
 * @property {string} statePath
 */
class Config {

  constructor() {

    /**
     * @type {{statePath: null}}
     * @private
     */
    const _config = {
      statePath: null,
    };


    const getPropertyDefinition = (property) => ({

      configurable: false,

      enumerable: true,

      get: () => {

        if (!_config[property]) {

          throw new Error(
            `\`${property}\` not configured.  You must set config.${property} before attempting to use this value.`
          );

        }

        return _config[property];

      },

      set: (value) => _config[property] = value,

    });


    Object.defineProperties(this, {
      statePath: getPropertyDefinition('statePath'),
    });

  }

}


export default new Config();


// WEBPACK FOOTER //
// ./src/modules/editableContent/config.js